// The single place that resolves the webgpu-vs-webgl three.js fork. Every other module
// must import THREE from here — importing 'three' or 'three/webgpu' directly would work
// on one renderer branch and silently break on the other.
import * as THREE1 from 'three'
import * as THREE2 from 'three/webgpu'

export const __DEFAULT_SMOOTH_TIME = 0.42;
export const isChrome = navigator.userAgent.includes("Chrome");
export const THREE = isChrome ? THREE2 : THREE1;

export const { DEG2RAD } = THREE.MathUtils

export const prefValue = "performance";
export const HIGH = "high-performance";
